import React from 'react';
import { withRouter } from 'react-router-dom';

function Header(props) {
    window.qstring = window.location.search;
    const qs = new URLSearchParams(window.location.search);
    const isMobileAppAlarmDetail = qs.get("MobileAppAlarmDetail") == 'true';
    const hideBackButton = props.isOnboard || isMobileAppAlarmDetail;

    const goBack = () => {
        const token = qs.get("token");
        props.history.push(`/live/?token=${token}`);
    }

  return (
    <header>
          <nav className="nav-bar">
              {!hideBackButton ? <span className="back" onClick={goBack}>
                  <i className="icon-back"></i>
              </span> : null}
            {/*   
            <a className="navbar-brand" href="#">
                <img src={props.logo} />
            </a> */}
            <span className="title">{props.shipName}</span>
        </nav>
    </header>
  );
}

export default withRouter(Header);